// isiPod
export default function(userAgent) {
  return userAgent.toLowerCase().indexOf('ipod') !== -1;
}
